import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { StoreService } from 'core/services/store.service';
import { ListOptions } from 'core/components/list';
import { TableDatasource } from '@gamelearn/skeletor/models';

// TODO this component maintains compatibility with admin tables and skeletor tables using the "skeletor" attribute, delete when not needed
@Component({
  selector: 'lms-filter-toggler',
  templateUrl: './filter-toggler.component.html',
  styleUrls: ['./filter-toggler.component.scss']
})
export class FilterTogglerComponent implements OnInit, OnDestroy {
  @Input() listId: string;
  @Input() skeletor: boolean = false; // TODO flag to maintain compatibility true for skeletor table false for admin old ones
  public listSubscription: Subscription;
  public showFilterRow = false;
  private listOptions: ListOptions;
  private tableDatasource: TableDatasource;
  private $filter: string;

  constructor() {}

  ngOnInit() {
    this.listSubscription = StoreService.get(this.listId).subscribe((data) => {
      if (this.skeletor) {
        this.showFilterRow = data && data.showFilterRow;
        this.tableDatasource = data;
      } else {
        this.showFilterRow = data && data.showFilterRow;
        this.listOptions = data;
      }
    });
  }

  ngOnDestroy() {
    this.listSubscription.unsubscribe();
  }

  toggleFilters() {
    this.setShowFilterRow(!this.showFilterRow);
  }

  setShowFilterRow(flag) {
    if (this.skeletor) {
      this.tableDatasource.showFilterRow = flag;
      this.tableDatasource.search = null;
      this.tableDatasource.refresh();
      StoreService.update(this.listId, this.tableDatasource);
    } else {
      const active = !!(
        this.listOptions.search ||
        (this.listOptions.filters && this.listOptions.filters.get('$filter'))
      );
      const filters = new Map<string, string>(this.listOptions.filters).set('$filter', '');
      StoreService.merge(this.listId, { showFilterRow: flag, search: null, filters, active });
    }
  }
}
